import { gql } from "@apollo/client";

export const GET_LICENSE_FEATURE_GROUP_NAME = "GetLicenseFeatureGroupsQuery";
export const GET_LICENSE_FEATURE_GROUP_FIELDS = gql`
  fragment LicensesFragment on Licenses {
    license_feature_groups {
      description
      features {
        description
        id
        id_feature_group
        id_feature_type
        is_enabled_by_default
        name
      }
      id
      id_feature_group
      name
    }
  }
`;
export const GET_LICENSE_FEATURE_GROUP_QUERY = gql`
  ${GET_LICENSE_FEATURE_GROUP_FIELDS}
  query ${GET_LICENSE_FEATURE_GROUP_NAME} {
  licenses {
    ...LicensesFragment
  }
}
`;

export const ADD_FEATURE_GROUP = gql`
  mutation AddFeatureGroup($name: String!, $description: String!) {
    create_feature_group(description: $description, name: $name) {
      success
      message
    }
  }
`;

export const DELETE_FEATURE_GROUP = gql`
  mutation RemoveFeatureGroup($ids: [Int!]!) {
    delete_feature_group(ids: $ids) {
      success
      message
    }
  }
`;

export const ADD_FEATURE_TYPE = gql`
  mutation AddFeatureType(
    $name: String!
    $description: String!
    $id_feature_group: Int!
    $is_enabled_by_default: Boolean!
  ) {
    create_feature_type(
      description: $description
      id_feature_group: $id_feature_group
      is_enabled_by_default: $is_enabled_by_default
      name: $name
    ) {
      success
      message
    }
  }
`;

export const DELETE_FEATURE_TYPE = gql`
  mutation RemoveFeatureType($ids: [Int!]!) {
    delete_feature_type(ids: $ids) {
      success
      message
    }
  }
`;

export const UPDATE_FEATURE_TYPE = gql`
  mutation UpdateFeatureType(
    $id_feature_type: Int!
    $is_enabled_by_default: Boolean!
  ) {
    update_feature_type(
      id_feature_type: $id_feature_type
      is_enabled_by_default: $is_enabled_by_default
    ) {
      success
      message
    }
  }
`;

export const READ_LICENSE_LIMITS_NAME = "ReadLicenseLimitsQuery";
export const READ_LICENSE_LIMITS_QUERY = gql`
  query ${READ_LICENSE_LIMITS_NAME} {
  licenses {
    license_limits {
      default_value
      description
      enable
      id_limit_type
      name
    }
    }
  }
`;

export const CREATE_LICENSE_LIMIT = gql`
  mutation CreateLicenseLimit(
    $name: String!
    $default_value: Int!
    $description: String
    $enable: Boolean!
  ) {
    create_license_limit_type(
      name: $name
      default_value: $default_value
      description: $description
      enable: $enable
    ) {
      success
      message
    }
  }
`;

export const UPDATE_LICENSE_LIMIT = gql`
  mutation UpdateLicenseLimit(
    $id_limit_type: Int!
    $default_value: Int
    $enable: Boolean
  ) {
    update_license_limit_type(
      id_limit_type: $id_limit_type
      default_value: $default_value
      enable: $enable
    ) {
      success
      message
    }
  }
`;

export const DELETE_LICENSE_LIMIT = gql`
  mutation DeleteLicenseLimit($ids: [Int!]!) {
    delete_license_limit_type(ids: $ids) {
      success
      message
    }
  }
`;

export const READ_LICENSES_NAME = "ReadLicensesQuery";
export const READ_LICENSES_QUERY = gql`
  query ${READ_LICENSES_NAME}($name_filter: String, $cursor: String, $first: Int = 25) {
  licenses {
    templates {
      list(name__icontains: $name_filter, first: $first, after: $cursor) {
        edges {
          node {
            description
            id_license
            name
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
}
`;

export const READ_LICENSES_FOR_ACCOUNT_QUERY_NAME = "ReadLicensesForAccount";
export const READ_LICENSES_FOR_ACCOUNT_QUERY = gql`
  query ${READ_LICENSES_FOR_ACCOUNT_QUERY_NAME}($name: String = "") {
    licenses {
      templates {
        list(name__icontains: $name, first: 25) {
          pageInfo {
            hasNextPage
          }
          edges {
            node {
              name
              id_license
            }
          }
        }
      }
    }
  }
`;
